<h4 *ngIf="anyOnDemand">Individual On-Demand</h4>
<ng-container *ngFor="let course of courses">
  <div class="mb-5">
    <bxl-course-item [rootRoute]="'/conferences/' + conference.slug" [course]="course"></bxl-course-item>
  </div>
</ng-container>
